import React, { FC } from 'react';
import useTranslator from '../../../../hooks/useTranslator';
import FacebookButton from './FacebookButton';
import StyledAuthButtonDivider from './StyledAuthButtonDivider';

export interface FacebookLoginProps {
    isRegisterForm: boolean;
    handleFacebookLogin: (event: React.MouseEvent<HTMLButtonElement>) => void;
    isFacebookLoaded: boolean;
    isFacebookLoginDesktopEnabled?: boolean;
}

const FacebookLoginSection: FC<FacebookLoginProps> = ({
    isRegisterForm,
    handleFacebookLogin,
    isFacebookLoaded,
    isFacebookLoginDesktopEnabled,
}) => {
    const t = useTranslator();
    return (
        <>
            {!isRegisterForm && isFacebookLoginDesktopEnabled && (
                <>
                    <StyledAuthButtonDivider>{t('fblogin_Or')}</StyledAuthButtonDivider>
                    <FacebookButton handleFacebookAuthClick={handleFacebookLogin} isLoaded={isFacebookLoaded}>
                        {t('fblogin_Login with Facebook')}
                    </FacebookButton>
                </>
            )}
        </>
    );
};

export default FacebookLoginSection;
